<template lang="pug">
.login-page
  .login-page__inner
    p.login-page__heading {{copy.heading}}
      form.login-page__form(v-on:submit.prevent="processLogin")
        input.login-page__input.login-page__input--email(type='email', placeholder="Email Address", id="login-email", name="login-email", :disabled="isDisabled" required v-model="formData.loginEmail")
        div.login-page__input-wrapper
          input.login-page__input.login-page__input--password(:type="passwordFieldReveal ? 'text' : 'password'", placeholder="Password", id="login-password", name="login-password", auto-complete="current-password" spellcheck="false" :disabled="isDisabled" required v-model="formData.loginPassword")
          i.login-page__reveal.fas(@click="togglePasswordVisibility()" tabindex="0" role="button" :class="passwordFieldReveal ? 'fa-eye-slash' : 'fa-eye'")
        .registration-flyout__error-wrapper(v-if="isError")
          AlertError(:error="isError")
        input.login-page__input.login-page__input--submit(type='submit' :value="copy.signInButton" :disabled="isDisabled")
          
      a.login-page__reset(href="#" :class="isDisabled ? 'registration-flyout__disabled' : '' " @click="toggleResetPassword()") {{copy.forgotPassword}}
      p.login-page__register Don't have an account? 
        span(@click="toggleRegistration" :class="isDisabled ? 'registration-flyout__disabled' : '' ") Register Now 
      //- p.login-page__subheading {{copy.subHeading }}
      p.login-page__content(v-html="copyHTML")
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import loginCopy from "../../../../data/loginPage.json"
import AlertError from "../components/AlertError.vue"
export default {
  name: "PageLogin",
  components: {
    AlertError,
  },
  data() {
    return{
      copy: loginCopy.loginPage.default,
      copyEndpoint: '/api/userdashboard/getcontent/login',
      endpoint: '/api/account/login',
      passwordFieldReveal: false,
      copyHTML: '',
      formData: {
        loginEmail: '',
        loginPassword: ''
      }
    }
  },
  computed: {
		...mapGetters(["isError", "isDisabled", "isLoading"])
  },
	methods: {
		...mapMutations(["setRegistrationPage", "setDisabled", "setResetPassword", "setResetEmail", "setError", "setLoading"]),
		...mapActions(["getAccountInfo"]),
    processLogin(data) {
      data.preventDefault()
      // console.log(this.data)
      // console.dir(data) 
      // do stuff
      const endpoint = this.endpoint;
      const loginEmail = this.formData.loginEmail;
      const loginPassword = this.formData.loginPassword;
			const afToken = this.$root.token;
      // const formVals = {
      //   email: JSON.stringify(this.$refs['login-email'].value),
      //   password: JSON.stringify(this.$refs['login-password'].value)
      // }
      // console.log(formVals)
      this.setDisabled(true)
      this.setLoading(true)
      this.getAccountInfo({endpoint, loginEmail, loginPassword, afToken})
    },
    toggleRegistration() {
      this.setRegistrationPage(true)
      this.setError(false)
      this.setDisabled(false)
    },
    togglePasswordVisibility() {
      this.passwordFieldReveal = !this.passwordFieldReveal
    },
    toggleResetPassword() {
      // console.log(this.formData.loginEmail)
      this.setResetEmail(this.formData.loginEmail)
      this.setResetPassword(true)
    }

  },
  mounted() {
    this.setLoading(true)
    this.setError(false)
    fetch(this.copyEndpoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }).then((response) => response.json())
      .then((data) => {
        this.copyHTML = data.content
        setTimeout(() => {
          this.setLoading(false)
        }, 1500);
      });
  },
};
</script>

<style lang="scss">
.login-page {
  background: var(--registration-blue);
  color: $white;
  font-family: var(--registration-font-family);
  padding: 2.0625rem 3.3125rem 0 1.1875rem;
  &__inner {

  }
  &__heading {
      font-size: 2em;
      font-weight: 600;
      margin-bottom: var(--registration-gap-base);
      font-family: var(--registration-font-family-bold);
  }
  &__subheading {
      font-weight: 600;
      font-family: var(--registration-font-family-bold);
      font-size: 1.15em;
      margin-bottom: calc(var(--registration-gap-base)*.5);
      @media screen and (min-width: 768px) {
          margin-bottom: calc(var(--registration-gap-base)*2);
      }        
  }
  &__content {
      color: var(--registration-light-gray);
      font-family: var(--registration-font-family-serif);
      margin-bottom: var(--registration-gap-base);
      a {
          color: $white;
          font-weight: 600;
          &:hover {
              text-decoration: underline;
          }
      }
  }
  &__form {
      display: flex;
      flex: 1 1 auto;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
  }
  &__input-wrapper {
    display: flex;
    flex: 0 0 100%;
    position: relative;
  }
  &__reveal {
    font-size: 1.25em;
    max-height: 22px;
    margin: auto;
    position: absolute;
      top: 0;
      bottom: 10px;
      right: 25px;
  }
  &__input {
      background: none;
      flex: 0 0 100%;
      border-top: none;
      border-left: none;
      border-right: none;
      border-bottom: 4px solid var(--registration-light-gray);
      color: var(--registration-light-gray);
      margin-bottom: 12px;
      padding: calc(var(--registration-gap-base)*.5) 0;
      border-radius: 0;
      
      &::placeholder {
          color: var(--registration-light-gray);
      }
      &--email {
      }
      &--password {
          
      }
      &--submit,
      &[type='submit'],
      &--register {
          background-color: var(--registration-button-blue);
          border-bottom: none;
          color: $white;
          @media screen and (min-width: 768px) {
              flex: 0 1 49%;
          }
          &:hover{
              background-color: var(--registration-button-blue-hover)
          }
      }
      &--submit {
        margin-top: 1rem;
      }
      // &--register {
      //     background-color: var(--registration-button-teal);
      //     &:hover {
      //         background-color: var(--registration-button-teal-hover)
      //     }
      // }
  }
  &__reset {
      color: var(--registration-button-teal);
      display: block;
      font-weight: 400;
      margin-top: var(--registration-gap-base);
      margin-bottom: calc(var(--registration-gap-base));
      @media screen and (min-width: 768px) {
          margin-bottom: calc(var(--registration-gap-base) * 1.5);
      }        
      &:hover {
          color: var(--registration-button-teal-hover);
      }
  }
  &__register {
    color: #fff;
    @media screen and (min-width: 768px) {
      margin-bottom: calc(var(--registration-gap-base) * 3);
    } 
    span {
      color: var(--registration-button-teal);
      cursor: pointer;
      &:hover {
          color: var(--registration-button-teal-hover);
          text-decoration: underline;
      }
    }
  }
  &__content {
    strong {
      color: #fff;
    }
    a {
      color: var(--registration-button-teal);
      &:hover {
          color: var(--registration-button-teal-hover);
      }
    }
  }
}

</style>
